import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssuePresignedUrlInput,
  CreateIssuePresignedUrlResponse,
  MutationCreateLostAndFoundIssueDocumentPresignedUploadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateLostAndFoundIssueDocumentPresignedUploadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssuePresignedUrlInput]?: CreateIssuePresignedUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse>;
}

// SearchLostAndFoundIssueDocument Service
export const { createLostAndFoundIssueDocumentPresignedUrl, useCreateLostAndFoundIssueDocumentPresignedUrl } = ((): {
  createLostAndFoundIssueDocumentPresignedUrl: ServiceMethod;
  useCreateLostAndFoundIssueDocumentPresignedUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateLostAndFoundIssueDocumentPresignedUploadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssuePresignedUrlInput, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse> => {
        const args: MutationCreateLostAndFoundIssueDocumentPresignedUploadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createLostAndFoundIssueDocumentPresignedUploadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createLostAndFoundIssueDocumentPresignedUploadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createLostAndFoundIssueDocumentPresignedUrl: fetch,
    useCreateLostAndFoundIssueDocumentPresignedUrl: useService,
  };
})();
